var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatementCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70713 8.49991L11.8534 5.35359L11.8535 5.35352L12.9999 4.20709C13.1398 4.06724 13.235 3.88906 13.2736 3.69508C13.3122 3.5011 13.2924 3.30004 13.2167 3.11732C13.141 2.93459 13.0128 2.77842 12.8484 2.66853C12.6839 2.55865 12.4906 2.5 12.2928 2.5H3.70701C3.50923 2.5 3.3159 2.55865 3.15145 2.66853C2.98701 2.77842 2.85884 2.93459 2.78315 3.11732C2.70746 3.30004 2.68766 3.5011 2.72625 3.69508C2.76483 3.88906 2.86007 4.06724 2.99992 4.20709L7.2927 8.50009L2.99992 12.7929C2.86007 12.9328 2.76483 13.1109 2.72625 13.3049C2.68766 13.4989 2.70746 13.7 2.78315 13.8827C2.85884 14.0654 2.98701 14.2216 3.15145 14.3315C3.3159 14.4413 3.50923 14.5 3.70701 14.5H12.2928C12.4906 14.5 12.6839 14.4413 12.8484 14.3315C13.0128 14.2216 13.141 14.0654 13.2167 13.8827C13.2924 13.7 13.3122 13.4989 13.2736 13.3049C13.235 13.1109 13.1398 12.9328 12.9999 12.7929L8.70713 8.49991ZM12.2925 3.5003L11.2928 4.5H4.70741L3.70744 3.5L12.2925 3.5003ZM3.70732 13.4997L7.9998 9.20721L12.2924 13.5L3.70732 13.4997Z",
    fill: "#FF882F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatementCount);
export default __webpack_public_path__ + "static/media/statementCount.8e7178083523609732d2b40d299059f2.svg";
export { ForwardRef as ReactComponent };